import { FormSignatureCertificateModel } from './FormSignatureCertificateModel';

export class StatementFormModel
{
	public IsFormGenerated: boolean = false;
	public Hash256: string = "";
	public Hash512: string = "";
	public Signature: string | undefined = undefined;
	public SignatureDate: string | undefined = undefined;
	public Certificate: FormSignatureCertificateModel | undefined = undefined;
}
